import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Constants, checkPermission } from 'utils';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const Home = () => {
	const user = useSelector((state: RootState) => state.user);
	const dispatch = useDispatch();

	React.useEffect(() => {
	    dispatch({
	      type: 'SET_HEADER',
	      payload: {
	        title: 'Inicio',
	        onBack: null
	      }
	    });
	}, [dispatch]);

	if (!user) {
		return <Redirect to="/login" />
	}
	else {
		switch(user?.level_id) {
			case Constants.LEVELS.ADMIN:
				return <Redirect to="/admin/home" />
			break;

			case Constants.LEVELS.MODERATOR:
				if (checkPermission(Constants.MODULES.ADMIN_HOME,'read'))
					return <Redirect to="/admin/home" />
				if (checkPermission(Constants.MODULES.USERS,'read'))
					return <Redirect to="/admin/users" />
				else
					return <Redirect to="/home" />
			break;

			case Constants.LEVELS.CLIENT:
				return <Redirect to="/client/home" />
			break;

			case Constants.LEVELS.CLIENT_MODERATOR:
				if (checkPermission(Constants.MODULES.GRAPHICS,'read'))
					return <Redirect to="/client/home" />
				else
					return <Redirect to="/home" />
			break;

			default:
				return <Redirect to="/profile" />
			break;
		}
	}
}

export default Home;